export default {
    namespaced: true,
    state: {
        tableLoading: false,
        filterParams: {},
        statusesList: [],
    },
    mutations: {
        updateTableLoading(state, payload) {
            state.tableLoading = payload;
        },
        updateFilterParams(state, payload) {
            state.filterParams = payload;
        },
        updateStatusesList(state, payload) {
            state.statusesList = payload;
        },
    },
};
